import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function Integrations() {
  return <PlatformPage feature={platformFeatures['integrations']!} />
}
